var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlayFilledAlt = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 28C6.44772 28 6 27.5523 6 27V5.00004C6.00016 4.64265 6.19104 4.31251 6.50069 4.13406C6.81035 3.95561 7.1917 3.95599 7.501 4.13504L26.501 15.135C26.8094 15.3139 26.9992 15.6435 26.9992 16C26.9992 16.3566 26.8094 16.6861 26.501 16.865L7.501 27.865C7.34882 27.9534 7.17598 28 7 28Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlayFilledAlt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play--filled--alt.d6df93ae.svg";
export { ForwardRef as ReactComponent };